import request from '@utils/request'

export function fetchBrokerageList(params) {
  return request({
    url: `/admin/brokerage`,
    params,
  })
}

export function fetchBrokerage(seq) {
  return request({
    url: `/admin/brokerage/${seq || 0}`,
    method: 'get',
  })
}

export function fetchShareList(params) {
  return request({
    url: '/admin/brokerage/share',
    method: 'get',
    params,
  })
}

export function fetchBalanceList(params) {
  return request({
    url: '/admin/brokerage/balance',
    method: 'get',
    params,
  })
}

export function fetchAdjustList(params) {
  return request({
    url: '/admin/brokerage/adjust',
    method: 'get',
    params,
  })
}

export function createAdjust(data) {
  return request.post('/admin/brokerage/adjust', data)
}

export function createBrokerage(data) {
  return request.post('/admin/brokerage', data)
}

export function updateBrokerage(data) {
  return request.put(`/admin/brokerage/${data.seq}`, data)
}

export function fetchRelationList(params) {
  return request({
    url: '/admin/brokerage/relation',
    method: 'get',
    params,
  })
}
